import { Route, Routes } from 'react-router-dom';
import AdminPannel from './Admin/AdminPannel';
import './App.css';
import HomePage from './components/HomePage';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import { AudioProvider } from './context/AudioContext';
import Home from './Pages/Home';
// import Routers from './Routers/Routers';
import HomeRoutes from './Routers/HomeRoutes';
import ProductsDescription from './components/ProductsDescription';
import Profile from './components/Profile';
import Cart from './customer/Components/Cart/Cart';
import Checkout from './customer/Components/Checkout/Checkout';
import PaymentSuccess from './customer/Components/paymentSuccess/PaymentSuccess';
import Order from './customer/Components/orders/Order';
import OrderDetails from './customer/Components/orders/OrderDetails';
import Categories from './components/Categories';
import AboutUs from './components/AboutUs';

function App() {
  const isAdmin = true;
  return (
    <div className="">
      <AudioProvider>
        <Routes>
          {/* <Route path="/*" element={<HomeRoutes />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/user/profile" element={<Profile />} />
          <Route path="/products/:id" element={<ProductsDescription />} />
          <Route path="/account/order" element={<Order />} />
          <Route path="/account/order/:orderId" element={<OrderDetails />} />
          <Route path='/sign-up' element={<SignUp />} />
          <Route path='/sign-in' element={<SignIn />} />
          <Route path="/admin/*" element={<AdminPannel />} />

          <Route path="/payment/:orderId" element={<PaymentSuccess />} />

        </Routes>
      </AudioProvider>
    </div>
  );
}

export default App;
